// The number on the app icon (where the phone or computer shows one: an
// iPhone home screen web app, an installed app on a computer). The open app
// sets the exact count; while it is closed the service worker adds one per
// push notification. The count is kept in a cache so both sides see it.

const BADGE_CACHE = 'app-badge';
const BADGE_KEY = '/app-badge-count';

const badgeSupported = () =>
  typeof navigator !== 'undefined' && 'setAppBadge' in navigator;

async function storeCount(count: number) {
  if (typeof caches === 'undefined') return;

  const cache = await caches.open(BADGE_CACHE);
  await cache.put(BADGE_KEY, new Response(String(count)));
}

async function storedCount() {
  if (typeof caches === 'undefined') return 0;

  const cache = await caches.open(BADGE_CACHE);
  const response = await cache.match(BADGE_KEY);
  const count = Number.parseInt((await response?.text()) ?? '0', 10);

  return Number.isNaN(count) ? 0 : count;
}

export async function setAppBadgeCount(count: number) {
  if (!badgeSupported()) return;

  try {
    if (count > 0) {
      await navigator.setAppBadge(count);
    } else {
      await navigator.clearAppBadge();
    }

    await storeCount(count);
  } catch {
    // Not allowed here (no notification permission, say): nothing to show
  }
}

export async function increaseAppBadgeCount() {
  if (!badgeSupported()) return;

  try {
    await setAppBadgeCount((await storedCount()) + 1);
  } catch {
    // The cache could not be read: leave the badge as it is
  }
}
